import { Tag } from "components/ui/tag/Tag"
import { H3 } from "components/ui/typography/titles/Titles"
import { MDtoHTML } from "components/ui/MDtoHTML/MDtoHTML"
import { useMarkdownParser } from "hooks/useMarkdownParser.hook"
import { useMessage } from "hooks/message.hook"
import { ButtonSecondary } from "components/ui/buttons/ButtonSecondary/ButtonSecondary"
import { copyToClipboard } from "helpers/utils.helper"
import type { TRelease } from "types/releaseInformation.type"
import style from "./ChangelogItem.module.scss"

const { changeLogItem, date, left, right, tags, tagStyle, clickableHeader, copyLinkButton } = style

type Props = {
	changeLogData: TRelease
}

export const ChangelogItem = ({ changeLogData }: Props) => {
	const { sanitizedContent } = useMarkdownParser({ content: changeLogData.description })
	const { success } = useMessage()

	const anchorId = changeLogData.header
		.toLowerCase()
		.replace(/\s+/g, "-")
		.replace(/[^a-z0-9-]/g, "")

	const сopyLinkHandle = () => {
		const url = `${window.location.origin}${window.location.pathname}#${anchorId}`
		copyToClipboard(url)
		success("Link copied to clipboard")
	}

	return (
		<div id={anchorId} className={changeLogItem}>
			<div className={left}>
				<span className={date}>{changeLogData.date}</span>
				<H3 className={clickableHeader}>{changeLogData.header}</H3>
				<ButtonSecondary className={copyLinkButton} onClick={сopyLinkHandle}>
					Copy link
				</ButtonSecondary>
				{changeLogData.tags ? (
					<div className={tags}>
						{changeLogData.tags.map((tag, index) => (
							<Tag className={tagStyle} key={`${tag}-${index}`}>
								{tag}
							</Tag>
						))}
					</div>
				) : null}
			</div>
			<div className={right}>
				<MDtoHTML sanitizedContent={sanitizedContent} />
			</div>
		</div>
	)
}
